import Layout from '../../../Layout';
import Photos from './photos';

import * as S from './styles';
import useScrollToTop from '../../../../utils/useScrollToTop';

function Mentoring() {
  useScrollToTop();

  return (
    <Layout>
      <h2>Mentorias</h2>

      {/* <Photos /> */}

    </Layout>
  );
}

export default Mentoring;
